<script setup lang="ts">
import type { IImageDTO } from '~/interfaces/product/IProductPageData';

const props = defineProps<{
  image: IImageDTO
  alt: string
  loading?: boolean
  blurredImage?: string
}>()

const {
  image,
  alt,
  loading,
  blurredImage
} = toRefs(props)
</script>

<template>
  <picture>
        <source
v-if="image.imageAVIF && image.imageAVIF2X && !loading"
                type="image/avif"
                :srcset="`${image.imageAVIF} 1x,${image.imageAVIF2X} 2x`">
        <source
v-if="image.imageWEBP && image.imageWEBP2X && !loading"
                type="image/webp"
                :srcset="`${image.imageWEBP} 1x,${image.imageWEBP2X} 2x`">
        <source
v-if="image.imageJPG && image.imageJPG2X && !loading"
                type="image/jpg"
                :srcset="`${image.imageJPG} 1x,${image.imageJPG2X} 2x`">
        <img
            :alt="alt"
            loading="lazy"
            :src="loading ? blurredImage : image.imageJPG" >
  </picture>
</template>
